import { useEffect, useState } from 'react';

/** 미디어 쿼리가 맞는가 — 창 크기를 바꾸면 따라간다. */
function useMedia(query: string): boolean {
  const [hit, setHit] = useState(() => typeof window !== 'undefined' && !!window.matchMedia?.(query).matches);
  useEffect(() => {
    const mq = window.matchMedia?.(query);
    if (!mq) return;
    const on = () => setHit(mq.matches);
    on();
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, [query]);
  return hit;
}

/**
 * 폰 폭인가(md 미만 — `globals.css` 의 폰 규칙·`App.tsx` 폰 껍데기와 같은 경계).
 * CSS 로 안 되는 판단(예: 표가 PC 에서 저장한 칼럼 폭을 쓸지)에만 쓴다. 창 크기를 바꾸면 따라간다.
 */
export function usePhone(): boolean {
  return useMedia('(max-width: 767.98px)');
}

/** 넓은 PC(Tailwind 2xl = 1536px 이상) — 목록과 상세를 좌우로 나란히 둘 폭(거래처별 정산 10-29). */
export function useWide(): boolean {
  return useMedia('(min-width: 1536px)');
}
